import React from 'react';
import { Link, IndexLink } from 'react-router-dom';
import Autocomplete from 'react-google-autocomplete';
import { Typeahead } from 'react-bootstrap-typeahead';
import moment from 'moment';
import ReactLoading from 'react-loading';
import Modal from 'react-modal';
// import { createthis.props.history } from 'history';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from 'react-redux';
import * as marketingActions from '../../actions/marketingActions';
import { bindActionCreators } from 'redux';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import axios from 'axios';
import Signup from '../login/signup';
import OtpModal from '../login/otp';

import Signin from '../login/login';
import Forgot from '../common/forgotPassword';
import { Button } from 'react-bootstrap';
import ActivateAccount from '../common/accountActivation';
import ResetPassword from '../common/resetPassword';
import UnlockAccount from '../common/unlockAccount';
import UnsubscribeEmails from '../common/unsubscribeEmails';
var countries = require('country-data').countries
// const this.props.history = createthis.props.history();

// This is a class-based component because the current
// component at the top-level.
class Home extends React.Component {
	constructor(props) {
		super(props);
		
		this.state = {
			specializationList: [],
			isReady: false,
			specializationName: '',
			specialization: '',
			searchZipcode: '',
			quickSearchArray: '',
			signUpModelOpen: false,
			signInModelOpen: false,
			settingLocation: false,
		};
		this.onChange = this.onChange.bind(this);
		this.quickSearch = this.quickSearch.bind(this);
		this.openSignUpModal = this.openSignUpModal.bind(this);
		this.hideSignupModal = this.hideSignupModal.bind(this);
		this.openSignInModal = this.openSignInModal.bind(this);
		this.hideSigninModal = this.hideSigninModal.bind(this);
		this.closeSignupOpenSignin = this.closeSignupOpenSignin.bind(this);
		this.closeSigninOpenSignup = this.closeSigninOpenSignup.bind(this);
		this.openForgotModal = this.openForgotModal.bind(this);
		this.openOtpModal = this.openOtpModal.bind(this);
		this.closeOtpModal = this.closeOtpModal.bind(this);
		this.hideForgotModal = this.hideForgotModal.bind(this);
		this.closeForgotModal = this.closeForgotModal.bind(this);
		this.closeActivateOpenSigin = this.closeActivateOpenSigin.bind(this);
		this.closeResetOpenSigin = this.closeResetOpenSigin.bind(this);
		this.closeActive = this.closeActive.bind(this);
		this.closeReset = this.closeReset.bind(this);
		this.updateAddress = this.updateAddress.bind(this);

	}
	updateAddress(address) {
		let self = this;
		var placeSearch, autocomplete;
		var componentForm = {
			street_number: 'Street Number',
			route: 'Route',
			postal_town: 'Town',
			locality: 'locality',
			administrative_area_level_1: 'State ',
			country: 'country',
			postal_code: 'Zip Code'
		};

		for (var i = 0; i < address.address_components.length; i++) {
			var addressType = address.address_components[i].types[0];
			if (componentForm[addressType]) {
				let val = address.address_components[i][componentForm[addressType]];
				componentForm[addressType] = address.address_components[i].long_name;
			}

		}
		var zip = componentForm.postal_code != 'Zip Code' ? componentForm.postal_code + ', ' : ''
		var town = componentForm.postal_town != 'Town' ? componentForm.postal_town + ', ' : componentForm.locality != 'locality' ? componentForm.locality + ', ' : ''
		var country = componentForm.country != 'country' ? componentForm.country : ''
		country = country.toLowerCase()
		.split(' ')
		.map((s) => s.charAt(0).toUpperCase() + s.substring(1))
		.join(' ');
		localStorage.setItem('country_long',country);
		localStorage.setItem('localityCountry', country)

		self.setState({
			searchZipcode: zip + town + country
		}, () => {
			console.log("zipcode", this.state)
		})
	}
	openSignUpModal(userType) {
		localStorage.setItem('userType', userType)
		this.setState({ signUpModelOpen: true });
	}
	hideSignupModal() {
		this.setState({ signUpModelOpen: false });
	}
	openSignInModal(userType) {
		localStorage.setItem('userType', userType)
		this.setState({ signInModelOpen: true });
	}
	hideSigninModal() {
		this.setState({ signInModelOpen: false });
	}
	closeSignupOpenSignin() {
		
		this.hideSignupModal('1')
		this.openSignInModal('1')
		// this.setState({ signUpModelOpen: false, signInModelOpen: true }, () => {
		// })
	}
	closeSigninOpenSignup() {
		this.setState({ signUpModelOpen: true, signInModelOpen: false }, () =>{
			
		})

	}
	openForgotModal() {
		this.setState({ forgotModalOpen: true, signInModelOpen: false });
	}
	openOtpModal(data) {
		// debugger
		this.setState({ otpModalOpen: true, signInModelOpen: false, loginData: data });
	}
	closeOtpModal() {
		this.setState({ otpModalOpen: false, signInModelOpen: true });
	}
	closeForgotModal() {
		this.setState({ forgotModalOpen: false, signInModelOpen: true });
	}
	hideForgotModal() {
		this.setState({ forgotModalOpen: false, signInModelOpen: false });

	}
	closeActivateOpenSigin() {
		this.setState({ signInModelOpen: true, activateAccountModalOpen: false })
	}
	closeResetOpenSigin() {
		this.setState({ resetModalOpen: false })
		this.props.history.push('/')
	}
	closeActive() {
		this.setState({ activateAccountModalOpen: false })
		this.props.history.push('/');
	}
	closeReset() {
		this.setState({ resetModalOpen: false })
		this.props.history.push('/')
	}
	quickSearch(index, e) {
		var Qsearch = this.state.specializationList[index];
		localStorage.setItem('specializationName', Qsearch.label);
		localStorage.setItem('specializationId', Qsearch.id);
		this.props.history.push('/marketing/search-specialist');
		
	}
	search() {

		if (this.state.specialization != undefined || this.state.searchZipcode != undefined) {
			this.setState({
				isSearch: true,
				narrowFilter: true,
			});
			let state = this.state
			localStorage.setItem('zipcode', this.state.searchZipcode ? this.state.searchZipcode : '' );
			localStorage.setItem('specializationName', this.state.specializationName);
			localStorage.getItem('localityCountry') ? localStorage.getItem('localityCountry') : localStorage.setItem('localityCountry', 'India');
			localStorage.getItem('country_long') ? localStorage.getItem('country_long') : localStorage.setItem('country_long', 'India');
			localStorage.setItem('specializationId', this.state.specialization);
			this.props.history.push('/marketing/search-specialist');


		} else {
			toast.warning('Please select specialization or enter zipcode')
		}

	}
	onChange(event) {
		this.setState({
			isReady: true,
			[event.target.name]: event.target.value
		});
	}
	componentWillMount() {
		

		this.props.actions.getMarketSpecializationList(this.props);
		// localStorage.setItem('specializationName', '');
		// localStorage.setItem('specializationId', '');
		// localStorage.setItem('zipcode', '');
		// localStorage.setItem('locality', '')
		

	}
	componentDidMount() {
		
	let state = this;
    window.scrollTo(0, 0)
    localStorage.setItem('isDisclaimerBlog',true);

		navigator.geolocation.getCurrentPosition(
			function (position) {
				
				var lat = position.coords.latitude;
				var lng = position.coords.longitude;
				
				localStorage.setItem('lat', lat);
				localStorage.setItem('lng', lng);
				axios.get('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + "," + lng + '&key=AIzaSyBQQtO5Ia-kb95LB-pBnKeBDeN35Z2ybbk')
					.then(function (response) {
						if (response) {
							
							for (var i = 0; i < response.data.results.length; i++) {
								if (response.data.results[i].types[0] == 'country') {
									var countryshort = response.data.results[i].address_components[0].short_name;
									var countrylong = response.data.results[i].address_components[0].long_name;
									
									
									
									

									localStorage.setItem('country_short', countryshort)
									localStorage.setItem('country_long', countrylong)
									localStorage.setItem('Currentcountry', countrylong)
									localStorage.setItem('currency', countries[countryshort].currencies[0]);
									localStorage.setItem('calling_code', countries[countryshort].countryCallingCodes[0]);
									localStorage.removeItem('mileDistance', 0)
								}
								if(response.data.results[i].types[0] == "locality") {
									var locality = response.data.results[i].address_components[0].short_name;
									var localityState = response.data.results[i].address_components[2].long_name;
									var localityCountry = response.data.results[i].address_components[3].long_name;
									
									setTimeout(() => {
										localStorage.setItem('locality', locality)
										localStorage.setItem('localityState', localityState)
										localStorage.setItem('localityCountry', localityCountry)
										state.setState({ settingLocation: true })
										console.log("-------5000")
									}, 3000)

								}
							}
						}
						else {
						}
					})
			});





	}

	componentWillReceiveProps(nextProps) {

		var state = this.state;
		state.specializationList = (state.specializationList && state.specializationList.length > 0) ? state.specializationList : nextProps.specializationList;
		state.quickSearchArray = (state.specializationList && state.specializationList.length > 0) ? state.specializationList : nextProps.specializationList;
		this.setState(state);
	}
	

	render() {
		var specializationList = this.state.specializationList ? this.state.specializationList : [];
		let userLocation;
		if (localStorage.getItem('locality') && this.state.settingLocation) {
			console.log("true is here", localStorage.getItem('locality'))
            userLocation = `${localStorage.getItem("locality")}, ${localStorage.getItem("localityState")}, ${localStorage.getItem("localityCountry")}`
        } else {
            userLocation = "Turn On your Location"
        }
		
		return (
			<div>
				<section className="home-banner">
					<ToastContainer />
					<div className="container">
						<div className="row">
							<div className="col-sm-12">
								<div className="banner-content">
									<div className="banner-heading">
										<h1>Global Access to Healthcare</h1>
										<Button className="btn btn-sign-up" onClick={this.openSignUpModal.bind(this, '1')}>Sign Up</Button>
									</div>
									<div className="banner-form">
										{/* <form > */}
										{/* <div className="form-group">
											<span className="form-icon">
												<img src={require('../../images/images/speciality_icon.png')} alt="" />
											</span>

										</div> */}
										{/* form-group */}
										<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img/family_medicine.png')} alt="" /></i></span>
											{this.state.specialization && this.state.specialization != '' ?
												<Typeahead
													onChange={(selected) => {
														
														this.setState({
															isReady: true,
															specializationName: selected.length !== 0 ? selected[0].label : '',
															specialization: selected.length !== 0 ? selected[0].id : ''
														});
													}}
													id="123"
													options={specializationList}
													defaultValue={this.state.specialization}
													defaultSelected={[{ id: "123", label: this.state.specializationName }]}
												//placeholder="Speciality"
												/> : <Typeahead
													onChange={(selected) => {
														this.setState({
															isReady: true,
															specializationName: selected ? selected[0].label : '',
															specialization: selected ? selected[0].id : ''
														});
													}}
													id="123"
													options={specializationList}
													defaultValue={this.state.specialization}
													//defaultSelected={[{ id: "123", label: this.state.specializationName }]}
													placeholder="Speciality"
												/>
											}
										</div>
										{/* <ToastContainer /> */}
										<div className="input-group inputBg" style={{ marginTop: 10, marginBottom: 10 }}> <span className="input-group-addon"><i className="fa "><img src={require('../../images/img/map_icon.png')} alt="" /></i></span>
											{/* < input type="text" className="form-control" name="searchZipcode" placeholder="Near City, Zip Code" value={this.state.searchZipcode} onChange={this.onChange.bind(this)}  /> */}
											<Autocomplete
												id='autocomplete'
												className="form-control cityinput"
												data-toggle="tooltip"
												data-placement="right"
												title="Country, State and City will be automatically filled"
												id="inputAddress2"
												// placeholder="Near City, Zip Code"
												placeholder={userLocation}
												name="searchZipcode"
												value={this.state.searchZipcode} onChange={this.onChange.bind(this)}
												onPlaceSelected={this.updateAddress}
												types={['(regions)']}
												autoComplete='off'

											/>
										</div>
										<div className="form-group">
											<button type="button" className="btn btn-primary btn-search btn-search-responsive" onClick={this.search.bind(this)} >Search</button>
											<div className="searcg-specialist">
												<a href='#QS' >Top Specialities</a>
												<a href='#QS' >	<i className="fa fa-angle-down" ></i></a>
											</div>

										</div>
										{/* </form> */}
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<section className="er-app-bg">
					<div className="container">
						<div className="row">
							<div className="col-sm-8">
								<div className="er-app">
									<div className="er-app-icon">
										<img src={require('../../images/images/er_app_icon.png')} alt="" />
									</div>
									<div className="er-app-content">
										<h2>Install &nbsp;
								<br />The ER App</h2>
										<div className="erp-list">
											<ul>
												<li>
													<span className="erp-list-icon">
														<img src={require('../../images/images/app_location_icon.png')} alt="" />
													</span> Patients are no longer restricted to health specialists within their region</li>
												<li>
													<span className="erp-list-icon">
														<img src={require('../../images/images/download_app_icon.png')} alt="" />
													</span> Download the ER App to find credible specialists around the world</li>
												<li>
													<span className="erp-list-icon">
														<img src={require('../../images/images/consult_icon.png')} alt="" />
													</span> Consult with the specialist face to face or secured video conference</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
							<div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
								<div className="mobileIMg">
									<img src={require('../../images/Slicing/VectorSmartObject.png')} alt="Request Appointment" className="img-responsive" />
								</div>
								<div className="iconsstore">
									<div className="text-center middIcon">
										<Link to="/apps">
											<img src={require('../../images/images/appstore.png')} alt="App Store" />
										</Link>
										<Link to="/apps">
											<img src={require('../../images/images/google.png')} alt="App Store" />
										</Link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<section className="howitworks">
					<div className="posrelative">
						<div className="container">
							<div className="row">
								<div className="col-sm-12">
									<div className="text-center titleHeading" id="How-it-work" >
										<h2>How it works?</h2>
										<ul className="listItem">
											<li>
												<div className="imgBlock text-center">
													<img src={require('../../images/images/search_Speciliast.png')} alt="" />
													<p>Search
										<br />for a Specialist</p>
												</div>
											</li>
											<li>
												<div className="imgBlock text-center">
													<img src={require('../../images/images/schedule_Appointment.png')} alt="" />
													<p>Schedule an
										<br />appointment</p>
												</div>
											</li>
											<li>
												<div className="imgBlock text-center">
													<img src={require('../../images/images/payment_Details.png')} alt="" />
													<p>Enter Payment
										<br />details
									</p>
												</div>
											</li>
											<li>
												<div className="imgBlock text-center">
													<img src={require('../../images/images/track_appointment.png')} alt="" />
													<p>Track your
										<br />appointment
									</p>
												</div>
											</li>
											<li>
												<div className="imgBlock text-center">
													<img src={require('../../images/images/consult_specilist.png')} alt="" />
													<p>Consult with
										<br />your specialist
									</p>
												</div>
											</li>
											<li>
												<div className="imgBlock text-center">
													<img src={require('../../images/images/health_Records.png')} alt="" />
													<p>View health
										<br /> records
									</p>
												</div>
											</li>
										</ul>
									</div>
								</div>	</div>
						</div>
					</div>
				</section>
				<section className="benefits">
					<div className="container" id='Benifits'>
						<div className="row">
							<div className="col-sm-12">
								<div className="text-center titleHeading mr-tp-btm">
									<h2>Benefits of the ER App</h2>
								</div>
							</div>
						</div>
						<div className="row m-b-90">
							<div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
								<ul className="list-Circle">
									<li>
										<img src={require('../../images/images/circleIcon.png')} alt="" />
										<p>Access leading specialists
								<br /> around the globe
							</p>
									</li>
									<li>
										<img src={require('../../images/images/circleIcon.png')} alt="" />
										<p>Your health records		
								<br />stored securely
							</p>
									</li>
									<li>
										<img src={require('../../images/images/circleIcon.png')} alt="" />
										<p>E-prescriptions	

							</p>
									</li>
									<li>
										<img src={require('../../images/images/circleIcon.png')} alt="" />
										<p>No Upfront Cost
							</p>
									</li>
									
								</ul>
							</div>
							<div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
								<ul className="list-Circle">
									<li>
											<img src={require('../../images/images/circleIcon.png')} alt="" />
													<p>Health blogs from					
											<br />  around the world

										</p>
									</li>
									<li>
										<img src={require('../../images/images/circleIcon.png')} alt="" />
										<p>HIPAA and GDPR compliant			
								<br />Videoconferencing
							</p>
									</li>
									<li>
										<img src={require('../../images/images/circleIcon.png')} alt="" />
										<p>Verified reviews and ratings		
								</p>
									</li>
									<li>
										<img src={require('../../images/images/circleIcon.png')} alt="" />
										<p>Comprehensive specialist profiles</p>
									</li>

									
								</ul>
							</div>
							<div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
								<ul className="list-Circle">
								<li>
										<img src={require('../../images/images/circleIcon.png')} alt="" />
										<p>100% Vetted Specialists
							</p>
									</li>
									<li>
										<img src={require('../../images/images/circleIcon.png')} alt="" />
										<p>Track Appointment History
							</p>
									</li>
									
									<li>
										<img src={require('../../images/images/circleIcon.png')} alt="" />
										<p>Book appointments across 		
								<br />time zones</p>
									</li>
									{/* <li>
										<img src={require('../../images/images/circleIcon.png')} alt="" />
										<p>Track appointment
								<br /> and payment history
							</p>
									</li>
									<li>
										<img src={require('../../images/images/circleIcon.png')} alt="" />
										<p>Ability to upload
								<br /> health files</p>
									</li> */}
								</ul>
							</div>
						</div>
					</div>
				</section>
				<section className="getStarted">
					<div className="container">
						<div className="row">
							<div className="col-sm-12">
								<div id='QS' className="text-center titleHeading mr-tp-btm">
									<h2>Let's get started</h2>
									<p className="specilist">What type of specialist
						<br /> are you looking for</p>
								</div></div>
						</div>
						<div className="row">
							<div className="col-sm-12">
								<div className="mar-top-Bot">
									<ul className="startedList">
										<li>
											<Link to="#" >
												<div className="cart">
													<div id="parent">

														<div id="child">
															<div>	<img src={require('../../images/images/people.png')} alt="" /></div>
															<div className="nameCart" onClick={this.quickSearch.bind(this, 0)} >Family Medicine</div>
														</div>
													</div>
												</div>
											</Link>
										</li>
										<li>
											<Link to="#" >
												<div className="cart">
													<div id="parent">
														<div id="child">
															<div>	<img src={require('../../images/images/pediatrics.png')} alt="" /></div>
															<div className="nameCart" onClick={this.quickSearch.bind(this, 1)}>Pediatrics</div>
														</div>
													</div>
												</div>
											</Link>
										</li>
										<li>
											<Link to="#">
												<div className="cart">
													<div id="parent">
														<div id="child">
															<div>
																<img src={require('../../images/images/internalMedicines.png')} alt="" /></div>
															<div className="nameCart" onClick={this.quickSearch.bind(this, 2)} >Internal Medicine</div>
														</div>
													</div>
												</div>
											</Link>
										</li>
										<li>
											<Link to="#">
												<div className="cart">
													<div id="parent">
														<div id="child">
															<div>
																<img src={require('../../images/images/dentristry.png')} alt="" /></div>
															<div className="nameCart" onClick={this.quickSearch.bind(this, 3)} >Dentistry</div>
														</div>
													</div>
												</div>
											</Link>
										</li>

										<li>
											<Link to="#">
												<div className="cart">
													<div id="parent">
														<div id="child">
															<div>
																<img src={require('../../images/images/phycatry.png')} alt="" /></div>
															<p className="nameCart" onClick={this.quickSearch.bind(this, 4)} >Psychiatry</p>
														</div>
													</div>
												</div>
											</Link>
										</li>
										<li>
											<Link to="#">
												<div className="cart">
													<div id="parent">
														<div id="child">
															<div>
																<img src={require('../../images/images/cardiology.png')} alt="" /></div>
															<div className="nameCart" onClick={this.quickSearch.bind(this, 5)}>Cardiology</div>
														</div>
													</div>
												</div>
											</Link>
										</li>
										<li>
											<Link to="#">
												<div className="cart">
													<div id="parent">
														<div id="child">
															<div>
																<img src={require('../../images/images/gynaecology.png')} alt="" /></div>
															<div className="nameCart" onClick={this.quickSearch.bind(this, 6)}>Obstetrics Gynaecology</div>
														</div>
													</div>
												</div>
											</Link>
										</li>
										<li>
											<Link to="#">
												<div className="cart">
													<div id="parent">
														<div id="child">
															<div>
																<img src={require('../../images/images/Orthopedics.png')} alt="" /></div>
															<div className="nameCart" onClick={this.quickSearch.bind(this, 7)}>Orthopedics</div>
														</div>
													</div>
												</div>
											</Link>
										</li>
										<li>
											<Link to="#">
												<div className="cart">
													<div id="parent">
														<div id="child">
															<div>
																<img src={require('../../images/images/Ophtalmology.png')} alt="" /></div>
															<div className="nameCart" onClick={this.quickSearch.bind(this, 8)}>Ophthalmology</div>
														</div>
													</div>
												</div>
											</Link>
										</li>
										<li>
											<Link to="#">
												<div className="cart">
													<div id="parent">
														<div id="child">
															<div>
																<img src={require('../../images/images/neorology.png')} alt="" /></div>
															<div className="nameCart" onClick={this.quickSearch.bind(this, 9)}>Neurology</div>
														</div>
													</div>
												</div>
											</Link>
										</li>
										<li>
											<Link to="#">
												<div className="cart">
													<div id="parent">
														<div id="child">
															<div>
																<img src={require('../../images/images/Endocrynology.png')} alt="" /></div>
															<div className="nameCart" onClick={this.quickSearch.bind(this, 10)}>Endocrinology</div>
														</div>
													</div>
												</div>
											</Link>
										</li>
										<li>
											<Link to="#">
												<div className="cart">
													<div id="parent">
														<div id="child">
															<div>
																<img src={require('../../images/images/allergy.png')} alt="" /></div>
															<div className="nameCart" onClick={this.quickSearch.bind(this, 11)}>Allergy</div>
														</div>
													</div>
												</div>
											</Link>
										</li>
										<li>
											<Link to="#">
												<div className="cart">
													<div id="parent">
														<div id="child">
															<img src={require('../../images/images/dermotology.png')} alt="" />
															<p className="nameCart" onClick={this.quickSearch.bind(this, 12)}>Dermatology</p>
														</div>
													</div>
												</div>
											</Link>
										</li>
										<li>
											<Link to="#">
												<div className="cart">
													<div id="parent">
														<div id="child">
															<img src={require('../../images/images/Gastroenterology.png')} alt="" />
															<p className="nameCart" onClick={this.quickSearch.bind(this, 13)}>Gastroenterology</p>
														</div>
													</div>
												</div>
											</Link>
										</li>
										<li>
											<Link to="#">
												<div className="cart">
													<div id="parent">
														<div id="child">
															<img src={require('../../images/images/urology.png')} alt="" />
															<p className="nameCart" onClick={this.quickSearch.bind(this, 14)}>Urology </p>

														</div>
													</div>
												</div>
											</Link>
										</li>
									</ul>
								</div>
							</div></div>

					</div>
				</section>
				
				
				<section className="service-partners text-center">
					<p>Our Service Partners</p>
					<ul>
						<li>
							<img src={require('../../images/images/fixer_logo.png')} alt="" className="img-fluid" />
						</li>
						<li>
							<img src={require('../../images/images/google_logo.png')} alt="" className="img-fluid"/>
						</li>
						<li>
							<img src={require('../../images/images/ApiMedic.png')} alt="" className="img-fluid" />
						</li>
						<li>
							<img src={require('../../images/images/stripe_logo.png')} alt="" className="img-fluid stripe"/>
						</li>
						<li>
							<img src={require('../../images/images/tokbox.png')} alt="" className="img-fluid" />
						</li>
						<li>
							<img src={require('../../images/images/microsoft_logo.png')} alt="" className="img-fluid"/>
						</li>
						<li>
							<img src={require('../../images/images/plivo_logo.png')} alt="" className="img-fluid" />
						</li>
					</ul>
				</section>
				{this.state.signUpModelOpen ? <Signup show={this.state.signUpModelOpen} hideSignupModal={this.hideSignupModal} closeSignupOpenSignin={this.closeSignupOpenSignin.bind(this)} {...this.props} /> : ''}
				{this.state.signInModelOpen ? <Signin openModal={this.state.signInModelOpen} otpModal={this.openOtpModal}  hideSigninModal={this.hideSigninModal} closeSigninOpenSignup={this.closeSigninOpenSignup}
					openForgotModal={this.openForgotModal} emailToken={this.state.emailToken} {...this.props} /> : ''}
				{this.state.forgotModalOpen ? <Forgot forgotModalOpen={this.state.forgotModalOpen} hideForgotModal={this.hideForgotModal} closeForgotModal={this.closeForgotModal} {...props} /> : ''}
				{this.state.otpModalOpen ? <OtpModal otpModalOpen={this.state.otpModalOpen} loginData={this.state.loginData} 	closeOtpModal={this.closeOtpModal} {...this.props} />: ''}

				{this.state.activateAccountModalOpen ? <ActivateAccount activateModalOpen={this.state.activateAccountModalOpen} closeActivateOpenSigin={this.closeActivateOpenSigin} {...props} activationKey={this.state.activationKey} closeActive={this.closeActive} /> : ''}
				{this.state.resetModalOpen ? <ResetPassword resetModalOpen={this.state.resetModalOpen} closeResetOpenSigin={this.closeResetOpenSigin} resetkey={this.state.resetkey} {...props} closeReset={this.closeReset} />: ''}

				{this.state.unLockAccountModalOpen ? <UnlockAccount unLockModalOpen={this.state.unLockAccountModalOpen} closeUnLockAccountOpenSigin={this.closeUnLockAccountOpenSigin} {...props} unLockKey={this.state.unlockKey} closeunSubscribeEmails={this.closeunSubscribeEmailsModel} />: ''}
				{this.state.unLockAccountModalOpen ? <UnsubscribeEmails unSubscribeEmails={this.state.unSubscribeModalOpen} closeUnSubscribeOpenSigin={this.closeUnLockAccountOpenSigin} {...props} unLockKey={this.state.unlockKey} closeunSubscribeEmails={this.closeunSubscribeEmailsModel} />: ''}

			</div >
		)
	}
}
function mapStateToProps(state, ownProps) {

	return {
		specializationList: state.marketing.specializationList
	};
}

//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(marketingActions, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(Home);

// export default Home;
